import { useContext } from 'react';
import { CookieConsentContext } from '../contexts/CookieConsentContext';

/**
 * Hook for cookie consent. Must be used within CookieConsentProvider (AppLayout wraps the app with it).
 * Returns shared consent state so that e.g. saving in CookieConsentManager updates CookieBanner and hides it.
 */
export const useCookieConsent = () => {
  const ctx = useContext(CookieConsentContext);
  if (!ctx) {
    throw new Error('useCookieConsent must be used within CookieConsentProvider. Wrap your app with <CookieConsentProvider>.');
  }
  return ctx;
};
